<template>
  <v-dialog
    v-model="showModal"
    max-width="700"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-application-edit
        </v-icon> Assign App
      </h2>
      <v-form
        ref="form"
        v-model="isFormValid"
      >
        <v-container fluid>
          <v-card-text class="text-body-1">
            <v-row>
              <v-col
                cols="12"
                md="10"
              >
                <v-select
                  v-model="appModule"
                  menu-props="auto"
                  :items="appModules"
                  item-text="name"
                  item-value="id"
                  label="App Modules*"
                  :rules="[(v) => !!v || 'This field is required']"
                  single-line
                  outlined
                  dense
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="productType"
                  menu-props="auto"
                  :items="productList"
                  item-text="text"
                  item-value="value"
                  label="Product Type*"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="planType"
                  menu-props="auto"
                  :items="planTypes"
                  label="Plan Type"
                  item-text="text"
                  item-value="value"
                  hint="Choose a plan type if selected app module is 'Digital-Signage'."
                  persistent-hint
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
              >
                <v-select
                  v-model="subscriptionStatus"
                  menu-props="auto"
                  :rules="[(v) => !!v || 'This field is required']"
                  :items="subscriptionStatusTypes"
                  label="Subscription Status*"
                />
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="6"
              >
                <v-datetime-picker
                  v-model="trialEndsAt"
                  label="Trial Ends At*"
                  :text-field-props="{
                    suffix: userTimeZone
                  }"
                  :date-picker-props="{
                    headerColor: '#37474f',
                    min: minEndDate
                  }"
                  :time-picker-props="{
                    headerColor: '#37474f'
                  }"
                >
                  <template #dateIcon>
                    <v-icon
                      large
                      class="date-icon-style"
                    >
                      mdi-calendar
                    </v-icon>
                  </template>
                  <template #timeIcon>
                    <v-icon
                      large
                      class="date-icon-style"
                    >
                      mdi-alarm
                    </v-icon>
                  </template>
                </v-datetime-picker>
              </v-col>
            </v-row>
            <p class="text-sm-left">
              *Indicates required field
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="assignAppModule()"
            >
              Assign
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import moment from 'moment-timezone';

  export default {
    name: 'AssignAppModule',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        loading: false,
        showModal: true,
        isFormValid: false,
        appModule: [],
        productType: '',
        productList: [
          {
            text: 'BannerEx',
            value: 'bannerEx',
          },
          {
            text: 'Swift Check-In',
            value: 'swift-checkin',
          },
          {
            text: 'Swift Check-In Projects',
            value: 'swift-checkin-project',
          },
        ],
        planType: null,
        planTypes: [
          {
            text: 'Basic',
            value: 'basic',
          },
          {
            text: 'Advanced',
            value: 'advanced',
          },
          {
            text: 'Enterprise',
            value: 'enterprise',
          },
        ],
        subscriptionStatus: null,
        subscriptionStatusTypes: [
          {
            text: 'Trial',
            value: 'trial',
          },
          {
            text: 'Expired',
            value: 'expired',
          },
          {
            text: 'Active',
            value: 'active',
          },
        ],
        trialEndsAt: null,
        minEndDate: moment().format('YYYY-MM-DD'),
      };
    },
    computed: {
      appModules () {
        return this.$store.getters['organizations/getAppModules'];
      },
      userTimeZone () {
        var Zone = moment.tz.guess();
        var timezone = moment.tz(Zone).zoneAbbr();
        return timezone;
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.loading = true;
      await this.fetchAppModules();
      this.loading = false;
    },
    methods: {
      async fetchAppModules () {
        await this.$store.dispatch('organizations/fetchAppModules');
      },
      convertToGmt (date) {
        return moment(date).utc();
      },
      async assignAppModule () {
        if (this.$refs.form.validate() === false) {
          this.$store.dispatch('alert/onAlert', {
            message: 'Please fill the required fields before proceeding.',
            type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          return;
        }
        this.loading = true;
        const organizationlId = this.$route.params.organizationId;
        await this.$store.dispatch('organizations/assignOrgAppModule', {
          appModule: {
            app_modules: this.appModule.split(','),
            product_type: this.productType,
            plan_type: this.planType,
            subscription_status: this.subscriptionStatus,
            trial_ends_at: this.convertToGmt(this.trialEndsAt),
          },
          organizationId: organizationlId,
        }).then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'App module assigned successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.loading = false;
          this.$emit('success');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 21px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-right: 5px;
}
.v-input--selection-controls {
  margin-top: 0px;
}
.date-icon-style {
  color:#37474f;
}
</style>
